var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.841,
    height: 31.473,
    viewBox: "0 0 32.841 31.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M379.61,256.529a48.628,48.628,0,0,0-15.7-2.687,47.439,47.439,0,0,0-15.579,2.691l-.776.27.12.813a41.762,41.762,0,0,0,4.059,13.066,44.743,44.743,0,0,0,11.609,14.112l.632.521.632-.521a44.745,44.745,0,0,0,11.61-14.114,41.761,41.761,0,0,0,4.059-13.067l.12-.817Zm-2.352,1.328-13.287,10.954-13.294-10.959a45.061,45.061,0,0,1,13.23-2.026,46.114,46.114,0,0,1,13.352,2.031Zm-13.287,24.876c-9.467-8.059-12.6-16.455-13.883-22.794l13.883,11.444,13.884-11.446C376.573,266.277,373.439,274.674,363.971,282.734Z",
    transform: "translate(-347.551 -253.842)",
    fill: "#0065f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.2b011310e6b820086a40f229ae3b87c5.svg";
export { ForwardRef as ReactComponent };